import { computed, inject } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStateIcon } from '@/composables/useStateIcon';

export function useTestWorkQueueTypesOptions() {
  const { testWorkQueueTypes } = inject('constants');
  const { getTestWorkQueueTypeIcon } = useStateIcon();
  const i18n = useI18n();

  const testWorkQueueTypesOptions = computed(() => ([
    {
      value: testWorkQueueTypes.ISO_SKIPPED,
      label: i18n.t('Iso skipped'),
      icon: getTestWorkQueueTypeIcon(testWorkQueueTypes.ISO_SKIPPED),
    },
    {
      value: testWorkQueueTypes.REMOTE_PRINTING,
      label: i18n.t('Print in clinic'),
      icon: getTestWorkQueueTypeIcon(testWorkQueueTypes.REMOTE_PRINTING),
    },
    {
      value: testWorkQueueTypes.AUTOMATIC_DESIGN,
      label: i18n.t('Automatic design'),
      icon: getTestWorkQueueTypeIcon(testWorkQueueTypes.AUTOMATIC_DESIGN),
    },
    {
      value: testWorkQueueTypes.EXTERNAL_OF_PRIMOUP,
      label: i18n.t('External of PrimoUp'),
      icon: getTestWorkQueueTypeIcon(testWorkQueueTypes.EXTERNAL_OF_PRIMOUP),
    },
  ]));

  return { testWorkQueueTypesOptions };
}


